import React, { useRef } from "react";
import "./BottomSheet.css";

interface BottomSheetProps {
  isVisible: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const BottomSheet: React.FC<BottomSheetProps> = ({
  isVisible,
  onClose,
  children,
}) => {
  const sheetRef = useRef<HTMLDivElement>(null);
  // let startY = 0;
  // let currentY = 0;

  // const handleTouchStart = (e: TouchEvent) => {
  //   startY = e.touches[0].clientY;
  //   if (sheetRef.current) {
  //     sheetRef.current.style.transition = "none";
  //   }
  // };

  // const handleTouchMove = (e: TouchEvent) => {
  //   if (!sheetRef.current) return;
  //   currentY = e.touches[0].clientY;
  //   const deltaY = currentY - startY;
  //   if (deltaY > 0) {
  //     sheetRef.current.style.transform = `translateY(${deltaY}px)`;
  //   }
  // };

  // const handleTouchEnd = () => {
  //   if (!sheetRef.current) return;
  //   sheetRef.current.style.transition = "transform 0.3s ease-out";
  //   const deltaY = currentY - startY;

  //   if (deltaY > 150) {
  //     onClose();
  //   } else {
  //     sheetRef.current.style.transform = "translateY(0)";
  //   }
  // };

  // useEffect(() => {
  //   const sheet = sheetRef.current;
  //   if (!sheet) return;

  //   sheet.addEventListener("touchstart", handleTouchStart);
  //   sheet.addEventListener("touchmove", handleTouchMove);
  //   sheet.addEventListener("touchend", handleTouchEnd);

  //   return () => {
  //     sheet.removeEventListener("touchstart", handleTouchStart);
  //     sheet.removeEventListener("touchmove", handleTouchMove);
  //     sheet.removeEventListener("touchend", handleTouchEnd);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isVisible]);

  if (!isVisible) return null;

  return (
    <>
      <div className="bottom-sheet-overlay" onClick={onClose} />
      <div className="bottom-sheet-container" ref={sheetRef}>
        <div className="bottom-sheet-header">
          <div className="bottom-sheet-handle" />
        </div>
        <div className="bottom-sheet-content">{children}</div>
      </div>
    </>
  );
};
